<script>
import debounce from 'lodash.debounce'
import axios from 'axios'
import TwDropdownSelectorWithSearch from '@/components/generic/forms/tw-dropdown-selector-with-search.vue'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'

export default {
  name: 'FundraiserPageSelectorPublic',
  components: {
    TwDropdownSelectorWithSearch
  },
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    fundraiser: {
      type: Object,
      required: true,
    },
    exceptIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      active: null,
      selectedResult: null,
      loadingSearching: false,
      validationErrorMessage: null,
      results: null,
      Query: '',
      SearchDebounced: null,
    }
  },
  computed: {
    searchQuery() {
      const returnable = {}
      if(this.Query) {
        if (this.fundraiser && this.fundraiser.settings && this.fundraiser.settings.lock_title) {
          returnable.name = this.Query
        }
        else {
          returnable.title = this.Query
        }
      }
      return returnable
    },
    fundraiserPageResults() {
      if (this.results && this.results.length > 0) {
        return this.results.filter(item => {
          return !this.exceptIds.includes(item.id) && item.object_type_short === 'FundraiserPage'
        })
      }
      return []
    }
  },
  watch: {
    Query(newQuery) {
      this.SearchDebounced(newQuery)
    },
    selectedResult(newVal) {
      this.$emit('update:modelValue', newVal)
    }
  },
  created() {
    this.SearchDebounced = debounce(this.search, 500)
  },
  methods: {
    async search(query) {
      if (!query || query.length < 3) return
      try {
        this.validationErrorMessage = null
        this.loadingSearching = true
        const data = await useFundraiserPagePublicStore(this.$options.name).fetchItems({
          clear: true,
          fundraiser_id: this.fundraiser.id,
          page: this.page,
          per_page: this.perPage,
          ...this.searchQuery,
          ...(this.team ? { team_id: this.team.id } : {}),
        })
        this.results = data.data
        this.loadingSearching = false
      } catch (e) {
        console.error(e)
        this.loadingSearching = false
        if (e.response) this.validationErrorMessage = e.response.data
        throw e
      }
    }
  },
}
</script>

<template>
  <div class="w-full">
    <tw-dropdown-selector-with-search v-model="Query" v-model:selected-option="selectedResult" :label-key="fundraiser.settings && fundraiser.settings.lock_title? 'cached.owner_name':'title'" avatar-key="cached.owner_avatar_url_small" :options="fundraiserPageResults" />
  </div>
</template>

<style scoped></style>
